export default {
	computed: {
		ehMobile() {
			return this.$vuetify.breakpoint.mobile
		},
		ehXs() {
			return this.$vuetify.breakpoint.xs
		},
		ehSm() {
			return this.$vuetify.breakpoint.sm
		},
		ehMd() {
			return this.$vuetify.breakpoint.md
		},
		ehLg() {
			return this.$vuetify.breakpoint.lg
		},
		ehXl() {
			return this.$vuetify.breakpoint.xl
		},
	},
	methods: {
		formatarLista(constant) {
			const list = Object.getOwnPropertyNames(constant).sort()
			if (list.indexOf('__ob__') >= 0) {
				list.splice(list.indexOf('__ob__'), 1)
			}
			return list
		},
		getConstantText(keyValue, constant, keyText) {
			if (!keyValue || !constant || !keyText) {
				return ''
			}

			return constant[keyValue][keyText]
		},
		getListTextConstant(constant, keyText) {
			return Object.keys(constant).map((key) => {
				return constant[key][keyText]
			})
		},
	},
}
